module.exports = Promise.all([parcelRequire.load("l6xiM"), parcelRequire.load("56LBA"), parcelRequire.load("58BxS")]).then(() => parcelRequire('6u5sT'));